export default class ClientAddController {
    constructor($location, $window, clientService) {
        this.$location = $location;
        this.$window = $window;
        this.clientService = clientService;
    }

    onSave() { 
        this.clientService.add(this.client).then(resp => {
            this.$location.path("/manage");
        });
    }

    goBack(){
        this.$window.history.back();
    }
}


// WEBPACK FOOTER //
// ./src/js/components/clients/clients.add.controller.js